import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import {
  PDA1050_R01Dto,
  PDA1050_R01Filter,
  PDA1050_R01HeaderDto,
  PDA1050_R01ItemDto,
  PDA1050_R01TransportDto,
} from "src/containers/PDA/PDA1050_R01/PDA1050_R01Dto";
import { getData, postData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1050_R01`;

/**
 * 검색 조건에 해당하는 입고 대상 발주 Header 목록을 조회한다.
 *
 * @param params 발주일자 범위, 발주번호 등 목록 검색 조건
 * @returns 공통 응답 형식으로 감싼 발주 Header 목록 조회 Promise
 */
export const getPDA1050_R01List = (params: PDA1050_R01Filter) =>
  getData<ResponseDto<PDA1050_R01HeaderDto[]>>(`${baseUrl}/orders`, {
    params,
  });

/**
 * 사용자가 선택한 발주의 Header와 품목별 Detail을 함께 조회한다.
 * URL 경로에 포함되는 발주번호는 특수문자로 인한 경로 오류를 방지하기 위해 인코딩한다.
 *
 * @param purchaseOrderNo 상세 조회할 발주번호
 * @returns 발주 Header 1건과 Detail 목록을 포함한 조회 Promise
 */
export const getPDA1050_R01One = (purchaseOrderNo: string) =>
  getData<ResponseDto<PDA1050_R01Dto>>(
    `${baseUrl}/order/${encodeURIComponent(purchaseOrderNo)}`
  );

/**
 * 스캔값으로 품목을 조회하고 해당 품목이 현재 발주에 포함되는지 서버에서 확인한다.
 * 서버는 바코드를 우선 조회하고, 일치하지 않으면 품목코드로 다시 조회한다.
 *
 * @param purchaseOrderNo 검증 기준이 되는 현재 발주번호
 * @param barcode 스캐너 또는 키보드로 입력된 바코드/품목코드
 * @returns 포장단위, 기입고량, 발주량 등이 포함된 품목 조회 Promise
 */
export const getPDA1050_R01ItemOne = (
  purchaseOrderNo: string,
  barcode: string
) =>
  getData<ResponseDto<PDA1050_R01ItemDto>>(`${baseUrl}/scan`, {
    params: { purchaseOrderNo, barcode },
  });

/**
 * 검수가 완료된 품목 목록을 입고등록 요청으로 서버에 전달한다.
 * 실제 입고, LOT 분할 및 매입 생성은 백엔드 트랜잭션에서 처리한다.
 *
 * @param data 발주번호, 입고일자, 창고 및 품목별 입고수량을 포함한 요청 DTO
 * @returns 생성 결과 메시지를 포함한 등록 Promise
 */
export const postPDA1050_R01 = (data: PDA1050_R01TransportDto) =>
  postData<PDA1050_R01TransportDto, ResponseDto<string>>(
    `${baseUrl}/transport`,
    data
  );
